"use client";

import { useClientContext } from "@/shared/components/Context";

import s from "./styles.module.css";

export default function LandingZoneComponent() {
  const { welcomeMovingFigure } = useClientContext();
  const style = {
    width: welcomeMovingFigure?.startRef.current?.clientWidth,
    height: welcomeMovingFigure?.startRef.current?.clientHeight,
  };

  return (
    <div
      style={style}
      className={s.wrapperForFigurePlaceholder2}
      ref={welcomeMovingFigure.setEndRef}
    >
      <div style={style} className={s.gradient} />
      <div className={s.pattern} />
    </div>
  );
}
